import logo from "@/assets/Wida.png"
import { Dialog, DialogClose, DialogContent, DialogFooter, DialogTitle } from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";

export default function AboutMe({ open, setOpen }) {
    return <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="min-w-[67%]">
            <div className="flex flex-wrap justify-center items-center">
                <div>
                    <DialogTitle className="text-2xl font-bold leading-tight my-3">About Me</DialogTitle>
                    <ul className="text-xl font-normal list-disc ml-13">
                        <li>19 year old, currently living in Vietnam.</li>
                        <li>My Birthday is November 29th, 2006</li>
                        <li>Started coding during the 2020 lockdown, just for fun!</li>
                        <li>Most of my projects are little experiments or fun requests from friends</li>
                        <li>Epic <a href="https://namemc.com/profile/2e9ca572-8533-4be4-847e-41439e0eddef">Minecraft</a> and <a href="https://gdbrowser.com/u/9454221">Geometry Dash</a> gamer.</li>
                        <li>Currently working for <a href="https://www.youtube.com/@explodingtnt">ExplodingTNT</a>'s Acting Server as Dev.</li>
                    </ul>
                </div>
                <img src={logo} alt="" className="w-64 h-64 m-10" />
            </div>
            <DialogFooter>
                <DialogClose asChild>
                    <Button variant="outline">Close</Button>
                </DialogClose>
            </DialogFooter>
        </DialogContent>
    </Dialog>
}